import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectCurrentUser, selectCurrentToken } from '../features/auth/authSlice';

const PrivateRoute = ({ children, roles }) => {
  const user = useSelector(selectCurrentUser);
  const token = useSelector(selectCurrentToken);
  const { i18n } = useTranslation();
  const lang = i18n.language;

  if (!token && !user) {
    const redirect = encodeURIComponent(window.location.pathname + window.location.search);
    return <Navigate to={`/${lang}/login?redirect=${redirect}`} />;
  }

  // If the user object is still loading, you might want to show a loader
  if (!user) {
    return <div>Loading user...</div>; // Or a proper spinner component
  }

  const userRole = user?.user?.role?.toUpperCase();
  if (roles && (!userRole || !roles.includes(userRole))) {
    // Logged in but role not authorized, redirect to a safe page
    return <Navigate to={`/${lang}/login`} />;
  }

  // Authorized, return the component
  return children;
};

export default PrivateRoute;

